import { Icon } from '@chakra-ui/react';

export const CardView = (props) => (
  <Icon viewBox="0 0 24 24" boxSize="16px" color="icon.g1" {...props}>
    <path
      d="M4.99994 9L6.19994 9L6.19994 15H4.99994L4.99994 9ZM9.99994 16.6C9.44765 16.6 8.99994 16.1523 8.99994 15.6V8.4C8.99994 7.84772 9.44765 7.4 9.99994 7.4H13.9999C14.5522 7.4 14.9999 7.84772 14.9999 8.4V15.6C14.9999 16.1523 14.5522 16.6 13.9999 16.6H9.99994ZM17.7999 9L18.9999 9L18.9999 15H17.7999L17.7999 9Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </Icon>
);
